import script from "./MemberListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberListItem.vue?vue&type=script&lang=ts&setup=true"

import "./MemberListItem.vue?vue&type=style&index=0&id=649d9726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649d9726"]])

export default __exports__